module.exports = __webpack_public_path__ + "static/media/comment5_1.f593b4ca.png";